import { useEffect } from "react";
import useEntities from "./app/hooks/useEntities";
import useTableData from "./app/hooks/useTableData";
import { useAppDispatch, useAppSelector } from "./app/store";
import { clearFilter } from "./app/store/reducers/appSlice";
import Filter from "./components/filter";
import { prepareFilterQuery } from "./components/filter/utils";
import Grid from "./components/grid";
import i18n from "./i18n";
import { AppContainer } from "./styles";

function App() {
  const dispatch = useAppDispatch()
  const getTableData = useTableData()
  const filter = useAppSelector(store => store.AppSlice.filter)

  useEntities()

  const handleFilterSubmit = () => {
    getTableData({ filter: prepareFilterQuery(filter) })
  }

  const handleClearFilter = () => {
    dispatch(clearFilter())
    getTableData({ filter: {} })
  }

  useEffect(() => {
    // @ts-ignore
    if (window.wmLang) {
      // @ts-ignore
      i18n.changeLanguage(window.wmLang)
    }
  }, [])

  return (
    <AppContainer>
      <Filter
        onFilter={handleFilterSubmit}
        onClear={handleClearFilter}
      />
      <Grid />
    </AppContainer>
  );
}

export default App;
